<template>
  <v-flex xs12>
    <v-data-table
      :options.sync="options"
      :items-per-page="10"
      :custom-sort="customSort"
      :headers="headers"
      :items="admintags"
      :loading="loading"
      loading-text="Loading... Please wait"
      :single-expand="true"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-spacer></v-spacer>
          <tag-form
            v-on:create="addTag"
            tagType="admintag"
          />
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="remove(item.id)">
          <v-icon
            color="red"
            v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
          >
            mdi-delete
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:item.name="{ item }">
          <v-chip>{{ item.name }}</v-chip>
      </template>

    </v-data-table>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import TagForm from '../components/dialogs/TagForm.vue';

export default {
  name: 'Admintag',
  components: { TagForm },
  data: () => ({
    itemClone: {},
    admintags: [],
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['name'],
      sortDesc: [false],
      mustSort: true,
      multiSort: false,
    },
    headers: [
      { text: 'admintag', value: 'name' },
      { text: 'pois count', value: 'pois_count' },
      { text: 'geotags count', value: 'geotags_count' },
      { text: '', value: 'actions', sortable: false },
    ],
  }),

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    addTag() {
      this.getTags();
    },

    remove(id) {
      this.$confirm('Are you sure you want to delete this admintag?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .delete(`api/admin/poitag/${id}`)
          .then((response) => {
            if (response.data.success) {
              this.setSnack({
                color: 'green',
                text: 'deleted',
              });
              this.admintags = this.admintags.filter((e) => e.id !== response.data.result.id);
            }
          });
      });
    },

    getTags() {
      this.$requestHelpers
        .get('api/admin/poitag',
          { params: { fulldata: true } })
        .then((response) => {
          this.admintags = response.data;
          this.loading = false;
        });
    },

    customSort(items, index, isDesc) {
      const priorityTags = ['SWA', 'LHR'];

      items.sort((a, b) => {
        const aVal = a[index[0]];
        const bVal = b[index[0]];

        if (priorityTags.includes(a.name)) {
          return -1;
        }
        if (priorityTags.includes(b.name)) {
          return 1;
        }

        if (!isDesc[0]) {
          return aVal < bVal ? -1 : 1;
        }
        return aVal > bVal ? -1 : 1;
      });
      return items;
    },
  },

  created() {
    this.getTags();
  },
};
</script>
